module.exports = __webpack_public_path__ + "static/img/illustratepic_01.473ff4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ko/illustratepic_01.png
// module id = D6Hx
// module chunks = 1